var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.3-0.1H106.7C47.9-0.1,0,47.8,0,106.6v274.2c0,16.9,9.3,32.4,24.2,40.4c6.8,3.6,14.2,5.4,21.7,5.4 c8.9,0,17.7-2.6,25.4-7.7l84.5-56.4h121.5c58.8,0,106.7-47.9,106.7-106.7V106.6C384,47.8,336.1-0.1,277.3-0.1z M512,191.9v274.2 c0,16.9-9.3,32.4-24.2,40.4c-6.8,3.6-14.2,5.4-21.7,5.5c-8.9,0-17.7-2.6-25.4-7.7l-84.6-56.4H234.7c-30.9,0-58.6-13.5-78.1-34.6 l12.1-8.1h108.6c82.3,0,149.3-67,149.3-149.3V106.6c0-6.6-0.6-13-1.4-19.3C474.6,96.6,512,139.9,512,191.9L512,191.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.8097132986d841636c809e6a5fe80e54.svg";
export { ForwardRef as ReactComponent };